import { Filter } from 'lib/common/GlobalSearcher';

export type ReconciliationFilterOption = 'all' | 'reconciled' | 'unreconciled';

export const RECONCILIATION_FILTER_OPTIONS: {
  value: ReconciliationFilterOption;
  label: string;
}[] = [
  { value: 'all', label: 'Todos' },
  { value: 'reconciled', label: 'Conciliado' },
  { value: 'unreconciled', label: 'No conciliado' },
];

export const isReconciliationFilterOption = (
  value: unknown,
): value is ReconciliationFilterOption =>
  value === 'all' || value === 'reconciled' || value === 'unreconciled';

interface CreateGlobalSearcherFiltersParams {
  searchReconciliationFilter: ReconciliationFilterOption;
  setSearchReconciliationFilter: (value: ReconciliationFilterOption) => void;
  searchBusinessIdentifier: string;
  setSearchBusinessIdentifier: (value: string) => void;
  searchDescription: string;
  setSearchDescription: (value: string) => void;
  searchDebit: string;
  setSearchDebit: (value: string) => void;
  searchCredit: string;
  setSearchCredit: (value: string) => void;
  searchObservation: string;
  setSearchObservation: (value: string) => void;
  searchConciliationDate: string | null;
  setSearchConciliationDate: (value: string | null) => void;
}

export const createBankReconciliationGlobalSearcherFilters = ({
  searchReconciliationFilter,
  setSearchReconciliationFilter,
  searchBusinessIdentifier,
  setSearchBusinessIdentifier,
  searchDescription,
  setSearchDescription,
  searchDebit,
  setSearchDebit,
  searchCredit,
  setSearchCredit,
  searchObservation,
  setSearchObservation,
  searchConciliationDate,
  setSearchConciliationDate,
}: CreateGlobalSearcherFiltersParams): Filter[] => [
  {
    type: 'select',
    label: 'Conciliación',
    value: searchReconciliationFilter,
    setter: (value) => {
      if (!isReconciliationFilterOption(value)) {
        setSearchReconciliationFilter('all');
        return;
      }
      setSearchReconciliationFilter(value);
    },
    options: RECONCILIATION_FILTER_OPTIONS,
  },
  {
    type: 'text',
    label: 'RUT',
    value: searchBusinessIdentifier,
    setter: setSearchBusinessIdentifier,
  },
  {
    type: 'text',
    label: 'Movimiento',
    value: searchDescription,
    setter: setSearchDescription,
  },
  {
    type: 'text',
    label: 'Abono',
    value: searchDebit,
    setter: setSearchDebit,
  },
  {
    type: 'text',
    label: 'Cargo',
    value: searchCredit,
    setter: setSearchCredit,
  },
  {
    type: 'text',
    label: 'Observación',
    value: searchObservation,
    setter: setSearchObservation,
  },
  {
    type: 'singleDate',
    label: 'Fecha cartola',
    dateKey: 'conciliationDate',
    value: searchConciliationDate,
    setter: setSearchConciliationDate,
  },
];
